import React from "react";
import { Routes, Route } from "react-router-dom";
import { DesignProvider } from "./DesignContext";
import { Start, Questions, Design, Preview } from "./index";
import SharedCard from "./SharedCard";
import NameInput from "./NameInput";

const MemoCardRoutes = () => {
  return (
    <DesignProvider>
      <Routes>
        <Route path="/" element={<Start />} />
        <Route path="/questions" element={<Questions />} />
        <Route path="/design" element={<Design />} />
        <Route path="/name" element={<NameInput />} />
        <Route path="/preview" element={<Preview />} />
        <Route path="/shared" element={<SharedCard />} />
      </Routes>
    </DesignProvider>
  );
};

export default MemoCardRoutes;
